import { render, staticRenderFns } from "./Orderdetail.vue?vue&type=template&id=b7aae9d4&scoped=true&"
import script from "./Orderdetail.vue?vue&type=script&lang=js&"
export * from "./Orderdetail.vue?vue&type=script&lang=js&"
import style0 from "./Orderdetail.vue?vue&type=style&index=0&id=b7aae9d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7aae9d4",
  null
  
)

export default component.exports